module.exports = __webpack_public_path__ + "img/noData.d5dc5ddd.png";